export const isEmpty = (value) => (!value || value.trim() === '');